import { render, staticRenderFns } from "./invoicesaler.vue?vue&type=template&id=08fecaae&"
import script from "./invoicesaler.vue?vue&type=script&lang=js&"
export * from "./invoicesaler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports